import type { UppyFile } from "@uppy/core"
import type { UppyBody, UppyMeta } from "@/composables/useUppy"
import type { ServerResponseV1 } from "@/http"
import { v1 } from "@/axios"

interface MultipartUploadResponse {
  uploadId: string
  key: string
  fileName: string
  parts: Array<{
    partNumber: number
    presignedUrl: string
  }>
}

export async function createMultipartUpload(file: UppyFile<UppyMeta, UppyBody>, eventVaultId: number, albumId?: number) {
  const response = await v1.post<ServerResponseV1<MultipartUploadResponse>>(`/upload/${eventVaultId}/multipart/create`, {
    fileName: file.name,
    contentType: file.type || "application/octet-stream",
    eventVaultId,
    albumId,
  })

  return response.data
}
